/** A closed screen's band and its message, centred on the window's width (the owner's order of 3 Nov 2026): a flex
 * row, not the hero's grid, and the message as wide as it may be up to its measure. */
export const CLOSED_BAND = "flex min-h-[60vh] w-full items-center justify-center bg-base-200 px-4 py-8";
export const CLOSED_MESSAGE = "w-full max-w-md mx-auto text-center";
